import { Button, colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const EmptyStateStyled = styled.div`
  ${typography.regular[16]};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
`;

export const EmptyStateLabelStyled = styled.p`
  ${typography.regular[16]};
  color: ${colors.neutral[900]};
  margin: 0;
  padding: 0;
`;

export const ProductLineSectionStyled = styled.section`
  background-color: ${colors.neutral.white};
  border-radius: 10px;
  padding: 3rem;
`;

export const SectionHeaderStyled = styled.header`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  margin-bottom: 0;

  ${breakpointsMQ4.md.down} {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const SectionTitleStyled = styled.h2`
  ${typography.bold[20]};
  margin: 0;
  color: ${colors.neutral[700]};
`;

export const ProductLineBlockStyled = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.neutral[100]}80;
  border: 1px solid ${colors.neutral[300]};
  border-radius: 1rem;
  padding: 1.6rem 3rem 3rem;
  gap: 3rem;
  margin-top: 3rem;
`;

export const SectionInfoStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const SectionInfoWrapperStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;
`;

export const SectionTitleSubtitleStyled = styled.p`
  ${typography.regular[14]};
  color: ${colors.neutral[700]};
  margin: 0;
  padding: 0;
`;

export const ToggleButtonStyled = styled(Button)`
  font-size: 1.6rem;
`;

export const IconWrapperStyled = styled.div<{ $accentColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 5rem;
  height: 5rem;
  border-radius: 10px;
  padding: 0.5rem;
  box-sizing: border-box;
  background-color: ${({ $accentColor }): string => $accentColor};
`;
